<template>
  <b-modal @ok="onConfirm" @cancel="onCancel" :title="title" :size="size" :ok-title="okTitle" :cancel-title="cancel"
           ref="modal">
    <slot>Are you sure?</slot>
  </b-modal>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'Confirm' },
    autoConfirm: { type: Number, default: null },
    size: { type: String, default: 'sm' },
    ok: { type: String, default: 'Ok' },
    cancel: { type: String, default: 'Cancel' },
  },

  data() {
    return {
      autoConfirmDelay: this.autoConfirm,
    }
  },

  computed: {
    okTitle() {
      if (this.autoConfirm === null) return this.ok
      return `${this.ok} (${parseInt(this.autoConfirmDelay)})`
    },
  },

  methods: {
    show() {
      if (this.autoConfirm) this.setAutoConfirm()
      this.$refs.modal.show()
    },

    setAutoConfirm() {
      this.autoConfirmDelay = this.autoConfirm
      this.autoConfirmInterval = setInterval(() => {
        this.autoConfirmDelay = this.autoConfirmDelay - 0.5
      }, 500)

      this.autoConfirmTimeout = setTimeout(() => {
        clearInterval(this.autoConfirmInterval)
        this.confirm()
      }, this.autoConfirm * 1000)
    },

    resetAutoConfirm() {
      if (this.autoConfirmInterval) clearInterval(this.autoConfirmInterval)
      if (this.autoConfirmTimeout) clearTimeout(this.autoConfirmTimeout)
    },

    onConfirm() {
      this.resetAutoConfirm()
      this.$emit('ok')
      this.$refs.modal.hide()
    },

    onCancel() {
      this.resetAutoConfirm()
      this.$emit('cancel')
    }
  }
}
</script>